export enum ObsessedEngineeringComponentShipmentStatus {
    Draft = 'Draft',
    Complete = 'Complete',
}
